import { render, staticRenderFns } from "./cis-users.vue?vue&type=template&id=1a6ec61a"
import script from "./cis-users.vue?vue&type=script&lang=js"
export * from "./cis-users.vue?vue&type=script&lang=js"
import style0 from "./cis-users.vue?vue&type=style&index=0&id=1a6ec61a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports